import { Client } from '../models/Organization'
import {
  addClient,
  addClients,
  removeClient,
  showAddClientDialog,
  updateSelectedClient,
} from '../actions/organization'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getIDToken } from '../utils/AuthUtil'
import { RootState } from '../store'
import { BASE_URL } from '../config'
import { fetchUserRecentFiles } from './filesService'

export const addClientAsync = createAsyncThunk(
  'organization/addClient',
  async (client: Client, { dispatch, getState }) => {
    const state = getState() as RootState
    const selectedOrganization = state.organization.selectedOrganization
    return fetch(`${BASE_URL}/api/clients/create`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(client),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(showAddClientDialog(false))
        dispatch(addClient(data))
      })
  },
)

export const fetchClients = createAsyncThunk(
  'organization/fetchClients',
  async (payload: { organizationId: string }, { dispatch }) => {
    fetch(`${BASE_URL}/api/clients/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filterBy: [
          {
            name: 'organization_id',
            value: payload.organizationId ? payload.organizationId : null,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(showAddClientDialog(false))
        dispatch(addClients(data))
      })
      .catch((error) => console.error('Error during fetching clients: ', error))
  },
)

export const deleteClientAsync = createAsyncThunk(
  'organization/deleteClient',
  async (payload: { clientId: string }, { dispatch, getState }) => {
    const state = getState() as RootState
    const data = { id: payload.clientId }

    fetch(`${BASE_URL}/api/clients/delete`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(removeClient(data))
        dispatch(updateSelectedClient())
        dispatch(fetchUserRecentFiles({ userId: state.auth.user?.id }))
      })
      .catch((error) => console.error('Error during deleting client: ', error))
  },
)
